// VineyardsManagementPage.js

import FieldsManagerComponent from "../components/FieldsData/FieldsManagerComponent";

const VineyardsManagement=()=>{
   return <FieldsManagerComponent />
};

export default VineyardsManagement;
